import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
interface LoginProps {
  onLogin: () => void;
}
export function Login({
  onLogin
}: LoginProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simple validation
    if (email && password) {
      onLogin();
      navigate('/');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-neutral-50" data-id="element-1127">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md" data-id="element-1128">
        <h1 className="text-2xl font-bold mb-6 text-center" data-id="element-1129">Mortgage CRM</h1>
        <form onSubmit={handleSubmit} data-id="element-1130">
          <div className="mb-4" data-id="element-1131">
            <label className="block text-sm font-medium mb-1" htmlFor="email" data-id="element-1132">
              Email
            </label>
            <input id="email" type="email" className="w-full p-2 border border-neutral-300 rounded" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-1133" />
          </div>
          <div className="mb-6" data-id="element-1134">
            <label className="block text-sm font-medium mb-1" htmlFor="password" data-id="element-1135">
              Password
            </label>
            <input id="password" type="password" className="w-full p-2 border border-neutral-300 rounded" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-1136" />
          </div>
          <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700" data-id="element-1137">
            Sign In
          </button>
        </form>
      </div>
    </div>;
}